enum AppMode {
  ANONYMOUS = 'Terminal',
  BACK_OFFICE = 'AdminTerminal',
}

export default AppMode;
